import { Avatar, styled } from "@mui/material";

const IconAvatarStyled = styled(Avatar)(({ theme }) => ({
  width: 24,
  height: 24,
  borderRadius: "50%",
  backgroundColor: "transparent",
  [theme.breakpoints.up("sm")]: {
    width: 30,
    height: 30,
  },
}));

export default IconAvatarStyled;
